import { NavLink } from "react-router-dom";
import useTranslate from "hooks/useTranslate";
import { useBreakpoint } from "hooks/useBreakpoint";
import { makeLangUrl } from "helpers/makeLangUrl";
import url from "../../../url";
import "./styles.sass";

type LoyaltyNickname = {
  nickname?: string;
};

const LoyaltyNickname = ({ nickname }: LoyaltyNickname) => {
  const t = useTranslate();
  const { isCustomBreakpointSmaller } = useBreakpoint(1180);
  const path = isCustomBreakpointSmaller
    ? makeLangUrl(url.routes.profile.personalInfo())
    : makeLangUrl(url.routes.profile.personal());

  const handleClick = () => {
    setTimeout(() => {
      const inputName =
        // eslint-disable-next-line quotes
        document.querySelector<HTMLInputElement>('[name="name"]');
      if (inputName) {
        inputName.focus({ preventScroll: false });
      }
    }, 100);
  };

  return nickname ? (
    <span className="LoyaltyNickname">{nickname}</span>
  ) : (
    <NavLink to={path} className="LoyaltyNickname" onClick={handleClick}>
      {t("profile.account.firstname")}
    </NavLink>
  );
};

export default LoyaltyNickname;
